var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_modal"},[_c('filter-modal'),_c('login-modal'),_c('qrcode-modal'),_c('change-order'),_c('cancel-order'),_c('calendar-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }